import type { ChartType, TimePeriod } from "./types";

export const GRID_LINE_COUNT = 6;
export const GRID_STROKE_PX = 1;
export const BALANCES_REPORT_QUERY_KEY = "dashboardBalancesReport";
export const HIDDEN_ACCOUNTS_REFRESH_DEBOUNCE_MS = 400;

// Tick labels are rendered inside a scaled `viewBox`, so their size in user
// units has to be divided by that scale to land on a fixed on-screen size.
export const TICK_LABEL_PX = 14;
export const MIN_TICK_FONT_SIZE = 10;
export const MAX_TICK_FONT_SIZE = 40;
// Vertical room a tick label needs, as a multiple of its font size.
export const TICK_LABEL_LINE_HEIGHT = 1.9;
// Horizontal room reserved for a currency-formatted value-axis label, in px.
export const VALUE_AXIS_LABEL_WIDTH_PX = 64;
export const MILLION = 1_000_000;

export const TICK_LABEL_FORMAT: Record<TimePeriod, string> = {
  year: "MMM",
  quarter: "MMM d",
  month: "MMM d",
} as const;

export const TIME_PERIODS: readonly TimePeriod[] = [
  "year",
  "quarter",
  "month",
] as const;

export const FALLBACK_TIME_PERIOD: TimePeriod = "month";

// The number of days at the start of a TimePeriod we allow to not have data.
export const TIME_PERIOD_COVERAGE_GRACE_DAYS = 3;

// Order the chart type options appear in the chart type popover.
export const CHART_TYPES: readonly ChartType[] = [
  "balances",
  "balance_owed",
] as const;

export const DEMO_BALANCE_THRESHOLD = 5;

/**
 * Hardcoded balances for the demo chart's monthly view, oldest first. One value
 * per day, so the last entry lands on the current day.
 */
export const DEMO_MONTHLY_BALANCES: readonly number[] = [
  8420.15, 8391.72, 8244.9, 8198.36, 8102.61, 7988.44, 7935.18, 9612.03,
  9540.77, 9411.29, 9376.85, 9188.42, 9034.6, 8897.31, 8812.05, 8659.74, 8503.9,
  8471.26, 8320.58, 8194.11, 9871.46, 9803.22, 9694.7, 9552.38, 9487.91,
  9339.05, 9210.63, 9102.47, 8988.2, 8874.56, 10460.32,
] as const;
